import { TStockAdjustment } from '@helpers/validation-schemas/warehouse-and-inventory/stock-adjustment.schema';
import { TWarehouse } from '@helpers/validation-schemas/warehouse-and-inventory/warehouse.schema';
import { formatDate } from '@utils/general/format-date';
import { formatDBDate } from '@utils/general/format-db-date';

const textColor = 'text-primary-dark';

const StockAdjustmentDetail = (props: { adjustment: TStockAdjustment }) => {
    const { adjustment } = props;
    console.log(adjustment);
    if (!adjustment) {
        return <div>No record found.</div>;
    }

    return (
        <div className="grid w-full grid-cols-2 gap-y-8">
            <div>
                <h5 className="mb-[0.70rem]">Adjustment Date</h5>
                <p className={textColor}>
                    {formatDate(
                        new Date(adjustment.inventory_adjustment_date)
                    ) || '-'}
                </p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Product Code</h5>
                <p className={textColor}>{adjustment.product_code || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Product Name</h5>
                <p className={textColor}>{adjustment.product_name || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Product Tag</h5>
                <p className={textColor}>
                    {adjustment.product_tag_name || '-'}
                </p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Unit Name</h5>
                <p className={textColor}>{adjustment.unit_name || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Quantity</h5>
                <p className={textColor}>{adjustment.qty || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Adjustment Method</h5>
                <p className={textColor}>
                    {adjustment.adjustment_method || '-'}
                </p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Allocation Account Name</h5>
                <p className={textColor}>{adjustment.warehouse_name || '-'}</p>
            </div>
            {/* <div>
                <h5 className="mb-[0.70rem]">Remark</h5>
                <p className={textColor}>{adjustment.remark || '-'}</p>
            </div> */}
            <div>
                <h5 className="mb-[0.70rem]">Description</h5>
                <p className={textColor}>{adjustment.description || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Created By</h5>
                <p className={textColor}>{adjustment.created_name || '-'}</p>
            </div>
            <div>
                <h5 className="mb-[0.70rem]">Created Time</h5>
                <p className={textColor}>{adjustment.created_time && formatDate(new Date(adjustment.created_time))}</p>
            </div>
        </div>
    );
};

export default StockAdjustmentDetail;
